import { useSubnav } from '@ally/next-subnav'
import { useHostServices } from '../../HostServices'
import { useAccountTypes } from '../../providers'
import { getFinancialHealthMenu } from './utils'

export const useDefaultSubnav = (): void => {
  const hostServices = useHostServices()
  const { featureFlags, session } = hostServices

  const { allAutoAccounts, isDebtPlanEnabled, isAutoUser } = useAccountTypes()

  const financialHealthEnabled = featureFlags.variation(
    'FF_credit-score',
    false,
  )

  const financialHealth = getFinancialHealthMenu({
    session,
    isDebtPlanEnabled,
    isAutoUser,
    allAutoAccounts,
    financialHealthEnabled,
  })

  useSubnav({
    hostServices,
    orderedSchema: [
      'transfers',
      'payments',
      'wealthOverview',
      'investments',
      'deposits',
      'manageCDs',
      'manageIRAs',
      'documents',
      'taxForms',
      financialHealth,
    ],
  })
}

export const useNoSubnav = (): void => {
  const hostServices = useHostServices()

  useSubnav({
    hostServices,
    orderedSchema: [],
  })
}
